<div class="container-fluid wrapper-page" id="doctorarea">

  <div align="center" class="page-head">
    <h4 class="mt-2 mb-2">DOCTOR AREA > PATIENT BOARD</h4>
  </div>


  <h5><a href="javascript:void(0)"><i class="fa fa-arrow-circle-left" (click)="getback()"> BACK
      </i></a>
  </h5>

  <div *ngIf="isPhyCheckOutLoading">
    <appLoader [size]="small" [display]="isPhyCheckOutLoading" [screen]="container" style="z-index: 1000;">
    </appLoader>
  </div>

  <!--nav Bar-->
  <div class="navbarmain justify-content-start ">

    <!-- menu class name changed:: class="nav-link" -->

    <a href="javascript:void(0)" class="btn btn-md btn-outline-primary mb-2 me-2">
      Patient Information</a>

    <a href="javascript:void(0)" (click)="habits()" class="btn btn-md btn-outline-primary mb-2 me-2">
      Habits</a>


    <a href="javascript:void(0)" (click)="history()" class="btn btn-md btn-outline-primary mb-2 me-2">
      History </a>


    <a href="javascript:void(0)" (click)="lifestyle()" class="btn btn-md btn-outline-primary mb-2 me-2">
      Life Style</a>

    <a href="javascript:void(0)" (click)="healthstatistics()" class="btn btn-md btn-outline-primary mb-2 me-2"
      *ngIf="ispastapt==false">
      Health Statistics</a>


    <a href="javascript:void(0)" (click)="pconsultations()" class="btn btn-md btn-outline-primary mb-2 me-2">
      Previous Consultations</a>


    <a href="javascript:void(0)" (click)="updocs()" class="btn btn-md btn-outline-primary mb-2 me-2">
      Uploaded Docs</a>


    <a href="javascript:void(0)" (click)="cconsultation()" class="btn btn-md btn-outline-primary mb-2 me-2">
      Current Consultation</a>


    <a href="javascript:void(0)" (click)="presc()" class="btn btn-md btn-outline-primary mb-2 me-2">
      Prescription</a>


    <a href="javascript:void(0)" (click)="labtes()" class="btn btn-md btn-outline-primary mb-2 me-2">
      Lab Test</a>

    <!-- <button class="btn btn-md btn-outline-primary mb-2 me-2" (click)="openEnd(contents)">Drug History</button>
    <button class="btn btn-md btn-outline-primary mb-2 me-2" (click)="openTop(content)">Pas tMedical
      History</button> -->
  </div>


  <div class="row main">
    <div class="col-lg-12">
      <div class="card pb-3 pt-3">

        <div class="container-fluid card" id="patientinformation">
          <div class="bg-primary text-white p-1" (click)="PI_panel_expa = !PI_panel_expa;">
            <h5 class="mt-2 ml-4">Patient Information
              <span *ngIf="!PI_panel_expa && !ispastapt" class="pull-right mr-4 ">
                <div (click)="PI_panel_expa = !PI_panel_expa; " class="accordianbutton"> + </div>
              </span>
              <span *ngIf="PI_panel_expa && !ispastapt" class="pull-right mr-4 ">
                <!-- <div (click)="PI_panel_expa = !PI_panel_expa;" class="accordianbutton"> - </div> -->
              </span>
            </h5>
          </div>
          <!--  PATIENT DETAILS -->
          <div class="card m-b-30" *ngIf="PI_panel_expa">
            <!-- <div class="card-body"> -->

            <div class="col-md-12 d-flex pt-2">

              <div class="col-md-2">
                <img src="{{p_purl}}" width="100px" onerror="this.src='assets/new-ui/images/users/avatar.jpg'"
                  class="image">
              </div>
              <div class="col-md-5">
                <div class="row marBt5">
                  <div class="col-5">
                    <label class="label1">Name:</label>
                  </div>
                  <div class="col-7">
                    <label class="label2">{{p_first_name}} {{p_last_name}}</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-5">
                    <label class="label1">Email:</label>
                  </div>
                  <div class="col-7 customa">
                    <label class="label2">{{p_email_id?p_email_id:"--"}}</label>
                  </div>
                </div>
                <div class="row marBt5">
                  <div class="col-5">
                    <label class="label1">Gender:</label>
                  </div>
                  <div class="col-7">
                    <label class="label2">{{p_gender?p_gender:"--"}}</label>
                  </div>
                </div>
                <div class="row marBt5">
                  <div class="col-5">
                    <label class="label1">Date of Birth:</label>
                  </div>
                  <div class="col-7">
                    <label class="label2">{{p_dob | date:'dd-MM-yyyy'}}</label>
                  </div>
                </div>
                <div class="row marBt5">
                  <div class="col-5">
                    <label class="label1">Address:</label>
                  </div>
                  <div class="col-7">
                    <label class="label2">{{p_address_1?.p_address_1}} {{p_address_2?.p_address_2}}
                      {{p_city_n}} {{p_state}}</label>
                  </div>
                </div>
                <div class="row marBt5">
                  <div class="col-5">
                    <label class="label1">Contact No:</label>
                  </div>
                  <div class="col-7">
                    <label class="label2">{{p_contact_no?p_contact_no:"--"}}</label>
                  </div>
                </div>
              </div>
              <div class="col-md-5">
                <div class="row marBt5">
                  <div class="col-7">
                    <label class="label1">Patient Since:</label>
                  </div>
                  <div class="col-5">
                    <label class="label2">{{since | date:'yyyy'}}</label>
                  </div>
                </div>
                <div class="row marBt5">
                  <div class="col-7">
                    <label class="label1">Drug Allergies:</label>
                  </div>
                  <div class="col-5" *ngIf="ispastapt==false;patient">
                    <!-- <label class="label2">--</label> -->
                    <label class="label2"> {{patient?.allergy?patient.allergy:'--'}}</label>
                  </div>

                </div>
                <div class="row marBt5">
                  <div class="col-7">
                    <label class="label1">Last Consultation Date:</label>
                  </div>
                  <div class="col-5">
                    <label class="label2">{{p_pre_consultdate | date:'dd-MM-yyyy'}}</label>
                  </div>
                </div>
                <div class="row marBt5">
                  <div class="col-7">
                    <label class="label1">Last follow-up request on:</label>
                  </div>
                  <div class="col-5">
                    <label class="label2">{{p_pre_followdate | date:'dd-MM-yyyy'}}</label>
                  </div>
                </div>

                <div class="row marBt5">
                  <div class="col-7">
                    <label class="label1">Reason for this Visit:</label>
                  </div>
                  <div class="col-5" *ngIf="ispastapt==false">
                    <label class="label2">{{reason?reason:'--'}}</label>
                  </div>
                  <div class="col-5" *ngIf="ispastapt==true">
                    <label class="label2">{{curr_reason}}</label>
                  </div>

                </div>


              </div>
            </div>
            <!-- </div> -->
            <!--  stats DETAILS -->

            <div class="container-fluid d-flex">

              <div class="navbar justify-content-md-evenly">
                <div *ngFor="let item of stats_current; let i = index;" class="mb-2" style="padding: 1px;">
                  <div class="card" style="height: 165px; width: auto;    display: inline-block;">
                    <div *ngIf="item.stats_std_val == null " class="card-body"
                      style="width: 150px;margin-bottom:-60px; padding: 5px;">
                      <a href="javascript:void(0)" class="nav-link" style="width: 130px;">-</a>
                    </div>

                    <div *ngIf="item.stats_std_val != null " class="card-body"
                      style="width: 150px;margin-bottom:-60px; padding: 5px;">
                      <a href="javascript:void(0)" class="nav-link"
                        [ngStyle]="{'background-color': item.compare=='red'? 'orange' : (item.compare=='green'? 'green' : (item.compare=='orange'? 'orange'  : 'black'))}"
                        style="width: 130px; color:azure ; ">{{item.stats_std_val}}</a>
                    </div>

                    <div class=" card-body" style="padding: 5px;">
                      <a href="javascript:void(0)" class="nav-link"
                        style="height: 87px; width: 130px; ">{{item.stats_name}}<br />
                        <span class="text-dark">({{item.stats_std_uom?item.stats_std_uom:'--'}})</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- </div> -->
            <div id="habits"></div>
          </div>
        </div>
        <br />
        <!-- ========================================================================================= -->

        <div id="history"></div>
        <form [formGroup]="forms['medicalInformation']">

          <!-- HABITS EDIT -->
          <div class="container-fluid" style="padding-top:0px;" *ngIf="ispastapt==false">
            <div class="bg-primary text-white p-1" (click)="PH_panel_expa = !PH_panel_expa; ">
              <h5 class="mt-2 ml-4">Personal Habits
                <span class="ml-4 accordiansubheading" (click)="openPrevhabit()">
                  Click here for Previous Records
                </span>
                <span *ngIf="!PH_panel_expa" class="pull-right mr-4 ">
                  <div (click)="PH_panel_expa = !PH_panel_expa; " class="accordianbutton">Edit</div>

                </span>
                <!-- <span *ngIf="PH_panel_expa" class="pull-right mr-4 ">
                  <div (click)="PH_panel_expa = !PH_panel_expa;" class="accordianbutton">X</div>
                </span> -->
              </h5>
            </div>

            <div class="card m-b-30 col-12">
              <!-- <div class="card-body" > -->
              <section class=" ml-2 container pt-3" *ngIf="PH_panel_expa">
                <div class="row" formArrayName="patient_appetite"
                  *ngFor="let item of getControl('patient_appetite')['controls']; let i = index;">

                  <div class="row" *ngIf="showFormArrayVal(i, 'patient_appetite', 'habit_id') !='Drugs'">

                    <div class="col-2 col-sm-8 col-md-2 m-m margin-top-20" [formGroupName]="i">
                      {{showFormArrayVal(i, 'patient_appetite', 'habit_id')}}
                    </div>

                    <div [formGroupName]="i" class="col-2 col-sm-8 col-md-2 m-m margin-top-20">
                      <div class="form-check form-check-inline">
                        <input class="form-check-input mb-0" type="radio" id="yes" formControlName="has_habit"
                          [value]=true (change)="checkedYes($event, i)" />
                        <label class="form-check-label" for="has_habit">Yes</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input mb-0" type="radio" id="no" formControlName="has_habit"
                          [value]=false (change)="checkedNo($event, i)" />
                        <label class="form-check-label" for="has_habit">No</label>
                      </div>
                    </div>

                    <div class="col-2 col-sm-8 col-md-2 m-m margin-top-20" [formGroupName]="i">
                      <editable (update)="updateField('patient_appetite')">
                        <ng-template viewMode>
                          Habit since {{showFormArrayVal(i, 'patient_appetite',
                          'since')}}
                        </ng-template>
                        <ng-template editMode>

                          <select formControlName="since" name="since" class="form-control">
                            <option value="">--Since--</option>
                            <option *ngFor=" let item of yearList" [value]="item">
                              {{ item }}
                            </option>
                          </select>

                        </ng-template>
                      </editable>
                      <div *ngIf="formValidation(i, 'habit_details', 'patient_appetite')" class="invalid-feedback">
                        Required</div>
                    </div>

                    <div class="col-2 col-sm-8 col-md-2 m-m margin-top-20" [formGroupName]="i">
                      <editable (update)="updateField('patient_appetite')">
                        <ng-template viewMode>
                          {{showFormArrayVal(i, 'patient_appetite',
                          'habit_details')}}
                        </ng-template>
                        <ng-template editMode>
                          <input class="form-control" formControlName="habit_details" focusable>
                        </ng-template>
                      </editable>
                      <div *ngIf="formValidation(i, 'habit_details', 'patient_appetite')" class="invalid-feedback">
                        Required</div>
                    </div>


                    <div class="col-2 col-md-2 margin-top-20" [formGroupName]="i">
                      <editable (update)="updateField('patient_appetite')">
                        <ng-template viewMode>
                          {{showFormArrayVal(i, 'patient_appetite',
                          'frequency')}}
                        </ng-template>
                        <ng-template editMode>
                          <select formControlName="frequency" class="form-control">
                            <option value="">--Select Frequency--</option>

                            <option *ngFor=" let x of freqList" [value]="x.value">
                              {{ x.value }}
                            </option>
                          </select>
                        </ng-template>
                      </editable>
                      <div *ngIf="formValidation(i, 'habit_details', 'patient_appetite')" class="invalid-feedback">
                        Required</div>
                    </div>
                  </div>
                </div>

              </section>
              <!-- </div> -->
            </div>
          </div>

          <!-- HABITS for Past Appointments -->
          <div class="container-fluid" id="habits" style="padding-top:0px;" *ngIf="ispastapt==true">
            <div class="bg-primary text-white p-1">
              <h5 class="mt-2 ml-4">Personal Habits
                <span class="pull-right mr-4" style="cursor: pointer;font-size: small;">
                  <div (click)="openPrevhabit()"> Click here for Previous Records </div>
                </span>
              </h5>
            </div>

            <div class="card m-b-30 col-12">
              <div class="card-body">
                <section class="mt-35 ml-2 container">
                  <div class="row mb-2" formArrayName="patient_appetite"
                    *ngFor="let item of getControl('patient_appetite')['controls']; let i = index;">
                    <div class="col-2 col-sm-8 col-md-2 m-m margin-top-20" [formGroupName]="i">
                      {{showFormArrayVal(i, 'patient_appetite', 'habit_id')}}
                    </div>

                    <div [formGroupName]="i" class="col-2 col-sm-8 col-md-2 m-m margin-top-20">
                      <div class="form-check form-check-inline">
                        <input disabled class="form-check-input mb-0" type="radio" id="yes" formControlName="has_habit"
                          [value]=true (change)="checkedYes($event, i)" />
                        <label class="form-check-label" for="has_habit">Yes</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input disabled class="form-check-input mb-0" type="radio" id="no" formControlName="has_habit"
                          [value]=false (change)="checkedNo($event, i)" />
                        <label class="form-check-label" for="has_habit">No</label>
                      </div>
                    </div>

                    <div class="col-2 col-sm-8 col-md-2 m-m margin-top-20" [formGroupName]="i">

                      {{showFormArrayVal(i, 'patient_appetite',
                      'habit_details')}}

                      <div *ngIf="formValidation(i, 'habit_details', 'patient_appetite')" class="invalid-feedback">
                        Required</div>
                    </div>

                    <div class="col-2 col-sm-8 col-md-2 m-m margin-top-20" [formGroupName]="i">
                      Habit since{{showFormArrayVal(i, 'patient_appetite',
                      'since')}}

                    </div>


                    <div class="col-2 col-md-2 margin-top-20" [formGroupName]="i">


                      {{showFormArrayVal(i, 'patient_appetite',
                      'frequency')}}

                      <div *ngIf="formValidation(i, 'habit_details', 'patient_appetite')" class="invalid-feedback">
                        Required</div>
                    </div>

                  </div>
                </section>
              </div>
            </div>
          </div>


          <!-- <ng-template #content let-offcanvas> -->
          <!-- <button type="button" class="btn-close" aria-label="Close"
              (click)="offcanvas.dismiss('Cross click')"></button> -->
          <div class="container-fluid " style="padding-top:0px;">
            <div class="bg-primary text-white p-1" (click)="PMH_panel_expa = !PMH_panel_expa;">
              <h5 class=" mt-2 ml-4">Past Medical History
                <span *ngIf="!PMH_panel_expa" class="pull-right mr-4 ">
                  <div (click)="PMH_panel_expa = !PMH_panel_expa; "
                    *ngIf="getControl('patient_med_history')['controls']?.length" class="accordianbutton"> View </div>
                  <div (click)="PMH_panel_expa = !PMH_panel_expa; "
                    *ngIf="getControl('patient_med_history')['controls']?.length==0" class="accordianbutton"> No Data
                  </div>
                </span>
                <span *ngIf="PMH_panel_expa" class="pull-right mr-4 ">
                  <div (click)="PMH_panel_expa = !PMH_panel_expa;" class="accordianbutton"> </div>
                </span>
              </h5>
            </div>

            <!-- <div *ngIf="getControl('patient_med_history')['controls']?.length && PMH_panel_expa"> -->
            <div class="card m-b-30 col-12">
              <!-- <div class="card-body" *ngIf="getControl('patient_med_history')['controls']?.length && PMH_panel_expa"> -->
              <section class="mt-35 ml-2 pt-3 container"
                *ngIf="getControl('patient_med_history')['controls']?.length && PMH_panel_expa">
                <div class="row mb-3" formArrayName="patient_med_history"
                  *ngFor="let item of getControl('patient_med_history')['controls']; let i = index;">
                  <div class="col-3 col-md-3" [formGroupName]="i">
                    <editable style="border-bottom: none;">
                      <ng-template viewMode>
                        {{showFormArrayVal(i, 'patient_med_history',
                        'disease_id')}}
                      </ng-template>
                    </editable>


                  </div>
                  <div class="col-3 col-md-3" [formGroupName]="i">
                    <editable style="border-bottom: none;">
                      <ng-template viewMode>
                        affected on {{showFormArrayVal(i, 'patient_med_history',
                        'since')}}
                      </ng-template>
                    </editable>
                  </div>

                  <div class="col-3 col-md-3" [formGroupName]="i">
                    <editable style="border-bottom: none;">
                      <ng-template viewMode>
                        {{showFormArrayVal(i, 'patient_med_history',
                        'med_hist_info')}}
                      </ng-template>

                    </editable>

                  </div>
                </div>


              </section>
              <!-- </div> -->
              <div *ngIf="getControl('patient_med_history')['controls']?.length==0 && PMH_panel_expa">
                <h5 class="text-center mt-2"> NO RECORDS FOUND</h5>
              </div>
            </div>
            <!-- </div> -->


            <!-- <ng-template #no_data_templ *ngIf="!PMH_panel_expa">
              <h5 class="mt-3 text-center mt-2"> NO RECORDS FOUND</h5>
            </ng-template> -->

          </div>
          <!-- </ng-template> -->


          <!-- Medicine History -->

          <!-- <ng-template #contents let-offcanvas> -->
          <div class="container-fluid" style="padding-top:0px;">
            <div class="bg-primary text-white p-1" (click)="DH_panel_expa = !DH_panel_expa; ">
              <h5 class="mt-2 ml-4">Drug History
                <span *ngIf="!DH_panel_expa" class="pull-right mr-4 ">
                  <div *ngIf="getControl('patient_medication')['controls']?.length"
                    (click)="DH_panel_expa = !DH_panel_expa; " class="accordianbutton"> View</div>
                  <div *ngIf="getControl('patient_medication')['controls']?.length==0"
                    (click)="DH_panel_expa = !DH_panel_expa; " class="accordianbutton"> No Data</div>
                </span>
                <span *ngIf="DH_panel_expa" class="pull-right mr-4 ">
                  <div (click)="DH_panel_expa = !DH_panel_expa;" class="accordianbutton"> </div>
                </span>
              </h5>
            </div>

            <!-- <div *ngIf="getControl('patient_medication')['controls']?.length;else no_data_templ"> -->
            <div class="card m-b-30 col-12">
              <!-- <div class="card-body" *ngIf="getControl('patient_medication')['controls']?.length && DH_panel_expa"> -->
              <section class="mt-35 ml-2 pt-3 container"
                *ngIf="getControl('patient_medication')['controls']?.length && DH_panel_expa">
                <div class="row mb-3" formArrayName="patient_medication"
                  *ngFor="let item of getControl('patient_medication')['controls']; let i = index;">
                  <div class="col-4 col-md-4" [formGroupName]="i">
                    <editable style="border-bottom: none;">
                      <ng-template viewMode>
                        {{showFormArrayVal(i, 'patient_medication',
                        'pmed_dose')}}
                      </ng-template>
                    </editable>

                  </div>

                  <div class="col-4 col-md-4" [formGroupName]="i">
                    <editable style="border-bottom: none;">
                      <ng-template viewMode>
                        {{showFormArrayVal(i, 'patient_medication',
                        'since')}}
                      </ng-template>

                    </editable>


                  </div>

                  <div class="col-4 col-md-4" [formGroupName]="i">
                    <editable style="border-bottom: none;">
                      <ng-template viewMode>
                        {{showFormArrayVal(i, 'patient_medication',
                        'pmed_freq')}}
                      </ng-template>

                    </editable>


                  </div>

                </div>
              </section>
              <!-- </div> -->

              <div *ngIf="getControl('patient_medication')['controls']?.length==0 && DH_panel_expa">
                <h5 class=" text-center mt-2"> NO RECORDS FOUND</h5>
              </div>

            </div>

            <!-- </div> -->

            <!-- <ng-template #no_data_templ>
              <h5 class="mt-3 text-center mt-2"> NO RECORDS FOUND</h5>
            </ng-template> -->
          </div>
          <!-- </ng-template> -->
          <div id="lifestyle"></div>
          <!-- Family Medical History -->
          <div class="container-fluid" style="padding-top:0px;">
            <div class="bg-primary text-white p-1" (click)="FMH_panel_expa = !FMH_panel_expa; ">
              <h5 class="mt-2 ml-4">Family Medical History
                <span *ngIf="!FMH_panel_expa" class="pull-right mr-4 ">
                  <div (click)="FMH_panel_expa = !FMH_panel_expa; " class="accordianbutton"> View </div>
                </span>
                <span *ngIf="FMH_panel_expa" class="pull-right mr-4 ">
                  <div (click)="FMH_panel_expa = !FMH_panel_expa;" class="accordianbutton"> </div>
                </span>
              </h5>
            </div>

            <div class="card m-b-30 ">
              <!-- <div class="card-body" *ngIf="FMH_panel_expa"> -->
              <section class=" mt-35 ml-2 pt-3 container" *ngIf="FMH_panel_expa">

                <div formArrayName="patient_fmed_history"
                  *ngFor="let item of getControl('patient_fmed_history')['controls']; let i = index;">
                  <div class="row mb-2 ml-2">
                    <div class="col-2 col-sm-3 col-md-2 m-m " [formGroupName]="i">
                      {{showFormArrayVal(i, 'patient_fmed_history', 'relation')}}
                    </div>

                    <div class="col-sm-12 col-md-7 margin-top-15 " [formGroupName]="i">
                      <input type="checkbox" id="yes" formControlName="diabetic" [value]=true disabled="disabled"
                        (change)="checkedYes($event, i)" style="cursor:not-allowed;" />
                      Diabetic
                      &nbsp;
                      <input type="checkbox" id="yes" formControlName="cardio" [value]=true disabled
                        (change)="checkedYes($event, i)" style="cursor:not-allowed;" />
                      Cardio Vascular
                      &nbsp;
                      <input type="checkbox" id="yes" formControlName="tension" [value]=true disabled
                        (change)="checkedYes($event, i)" style="cursor:not-allowed;" />
                      Hyper Tension
                      &nbsp;
                      <input type="checkbox" id="yes" formControlName="cholestral" [value]=true disabled
                        (change)="checkedYes($event, i)" style="cursor:not-allowed;" />
                      High Cholestral
                    </div>

                    <div class="col-2 col-sm-12 col-md-1  m-m margin-top-15" [formGroupName]="i">
                      <editable style="border-bottom: none;">
                        <ng-template viewMode>
                          {{showFormArrayVal(i, 'patient_fmed_history',
                          'status')}}
                        </ng-template>

                      </editable>
                      <div *ngIf="formValidation(i, 'status', 'patient_fmed_history')" class="invalid-feedback">
                        Required</div>
                    </div>
                    <div class="col-3 col-sm-12 col-md-2 m-m margin-top-15" [formGroupName]="i">
                      <editable style="border-bottom: none;">
                        <ng-template viewMode>
                          {{showFormArrayVal(i, 'patient_fmed_history',
                          'remarks')}}
                        </ng-template>

                      </editable>
                      <div *ngIf="formValidation(i, 'remarks', 'patient_fmed_history')" class="invalid-feedback">
                        Required</div>
                    </div>
                  </div>
                </div>
              </section>
              <!-- </div> -->
            </div>
          </div>
          <div id="healthstats"></div>

          <!-- LIFE STYLE -->
          <div class="container-fluid" style="padding-top:0px;" *ngIf="ispastapt==false">
            <div class="bg-primary text-white p-1" (click)="LS_panel_expa = !LS_panel_expa;">
              <h5 class="mt-2 ml-4">Life Style
                <span class="ml-4 accordiansubheading" (click)="openPrevlife()"> Click here for Previous Records</span>
                <span *ngIf="!LS_panel_expa" class="pull-right mr-4 ">
                  <div (click)="LS_panel_expa = !LS_panel_expa; " class="accordianbutton"> Edit </div>
                </span>
                <span *ngIf="LS_panel_expa" class="pull-right mr-4 ">
                  <div (click)="LS_panel_expa = !LS_panel_expa;" class="accordianbutton"> </div>
                </span>
              </h5>
            </div>

            <div class="card m-b-30 col-12">
              <!-- <div class="card-body" *ngIf="LS_panel_expa"> -->
              <section class="mt-35 ml-2 pt-3 container" *ngIf="LS_panel_expa">
                <div class="row  mb-3" formArrayName="patient_lifestyle"
                  *ngFor="let item of getControl('patient_lifestyle')['controls']; let i = index;">

                  <div class="col-4 col-md-4" [formGroupName]="i">
                    {{showFormArrayVal(i, 'patient_lifestyle', 'activity')}}
                  </div>

                  <div class="col-4 col-md-4" [formGroupName]="i">
                    <editable (update)="updateField('patient_lifestyle')">
                      <ng-template viewMode *ngIf=" i===0  || i===1 ">
                        {{showFormArrayVal(i, 'patient_lifestyle',
                        'duration')}} - hours
                      </ng-template>
                      <ng-template viewMode *ngIf=" i===2 ">
                        {{showFormArrayVal(i, 'patient_lifestyle',
                        'duration')}} - hours
                      </ng-template>
                      <ng-template editMode>
                        <input class="form-control" formControlName="duration" focusable>
                      </ng-template>
                    </editable>
                    <div *ngIf="formValidation(i, 'duration', 'patient_lifestyle')" class="invalid-feedback">
                      Required</div>
                  </div>

                  <div class="col-4 col-md-4" [formGroupName]="i">
                    <editable (update)="updateField('patient_lifestyle')">
                      <ng-template viewMode>
                        {{showFormArrayVal(i, 'patient_lifestyle',
                        'freq')}}
                      </ng-template>
                      <ng-template editMode>
                        <select formControlName="freq" class="form-control">
                          <option value="">--Select Frequency--</option>

                          <option *ngFor=" let x of freqList" [value]="x.value">
                            {{ x.value }}
                          </option>
                        </select>
                      </ng-template>
                    </editable>
                    <div *ngIf="formValidation(i, 'freq', 'patient_lifestyle')" class="invalid-feedback">
                      Required</div>
                  </div>

                </div>
              </section>
              <!-- </div> -->
            </div>
          </div>
          <div id="pconsultations"></div>
          <!-- LIFE STYLE for Past Appointments -->
          <div class="container-fluid" style="padding-top:0px;" *ngIf="ispastapt==true">
            <div class="bg-primary text-white p-1">
              <h5 class="mt-2 ml-4">Life Style
                <span class="pull-right mr-4" style="cursor: pointer;font-size: small;">
                  <div (click)="openPrevlife()"> Click here for Previous Records </div>
                </span>
              </h5>
            </div>


            <div class="card m-b-30 col-12">
              <div class="card-body">
                <section class="mt-35 ml-2 container">
                  <div class="row  mb-3" formArrayName="patient_lifestyle"
                    *ngFor="let item of getControl('patient_lifestyle')['controls']; let i = index;">

                    <div class="col-4 col-md-4" [formGroupName]="i">
                      {{showFormArrayVal(i, 'patient_lifestyle', 'activity')}}
                    </div>

                    <div class="col-4 col-md-4" [formGroupName]="i">

                      {{showFormArrayVal(i, 'patient_lifestyle',
                      'duration')}} - hours

                    </div>

                    <div class="col-4 col-md-4" [formGroupName]="i">

                      {{showFormArrayVal(i, 'patient_lifestyle',
                      'freq')}}

                    </div>

                  </div>
                </section>
              </div>
            </div>
          </div>

        </form>

        <!-- =============================HEALTH STATS EDIT=========================================== -->
        <div class="container-fluid" style="padding-top:0px;" *ngIf="ispastapt==false">
          <div class="bg-primary text-white p-1" (click)="PHS_panel_expa = !PHS_panel_expa; ">
            <h5 class="mt-2 ml-4">Patient Health Statistics
              <!-- <span class="ml-4 accordiansubheading" (click)="openPrevhabit()">
                Click here for Previous Records
              </span> -->
              <span *ngIf="!PHS_panel_expa" class="pull-right mr-4 ">
                <div (click)="PHS_panel_expa = !PHS_panel_expa; " class="accordianbutton"> Edit </div>
              </span>
              <span *ngIf="PHS_panel_expa" class="pull-right mr-4 ">
                <div (click)="PHS_panel_expa = !PHS_panel_expa;" class="accordianbutton"> </div>
              </span>
            </h5>
          </div>
          <div class="card m-b-30">
            <!-- <div class="card-body" *ngIf="PHS_panel_expa"> -->
            <section class="mt-35 ml-2 mt-2 container" *ngIf="PHS_panel_expa">
              <form [formGroup]="forms['patstats']">
                <ul class="ul1">
                  <li class="row mb-2 col-12 col-md-12" formArrayName="pat_stats"
                    *ngFor="let item of forms['patstats']?.get('pat_stats')['controls'] ; let i = index;">

                    <div class="col-4 col-md-4 mt-3 mb-2" [formGroupName]="i">
                      {{showFormArrayVal(i, 'pat_stats', 'stats_name')}}
                    </div>

                    <div class="col-4 col-md-4 mt-3 mb-2" [formGroupName]="i" *ngIf="i!=2">
                      <editable (update)="updateStats('pat_stats')">
                        <ng-template viewMode>
                          {{showFormArrayVal(i, 'pat_stats','stats_std_value')}}
                        </ng-template>

                        <ng-template editMode>
                          <input type="number" style="width:50px;height:40px;" formControlName="stats_std_value">
                        </ng-template>

                      </editable>
                      <span style="font-size: 12px;"> {{showFormArrayVal(i, 'pat_stats', 'stats_std_uom')}}</span>
                    </div>

                    <div class="col-4 col-md-4 mt-3 mb-2" [formGroupName]="i" *ngIf="i==2">
                      <editable (update)="updateStats('pat_stats')">
                        <ng-template viewMode>
                          {{showFormArrayVal(i, 'pat_stats','stats_std_value')}}
                        </ng-template>

                        <ng-template editMode>
                          <input style="width:120px;height:40px;" formControlName="stats_std_value"
                            placeholder="systolic/diastolic">
                        </ng-template>
                        ENTER THE VALUE by this format 'xxx/xxx'
                      </editable>
                      <span style="font-size: 12px;"> {{showFormArrayVal(i, 'pat_stats', 'stats_std_uom')}}</span>
                    </div>

                    <div class="col-sm-6 col-md-2 mt-3 mb-2" (click)="openPrestats(i)">
                      <i class="fa fa-info-circle" style="color:blue"> </i>
                    </div>
                    <div class="col-sm-6 col-md-2 mt-3 mb-2">
                    </div>
                  </li>
                  <li class="li1" *ngIf="forms['patstats']?.length % 2 != 0"></li>
                </ul>
              </form>

            </section>
            <!-- </div> -->
          </div>
        </div>
        <div id="updocs"></div>
        <!-- ============================PREVIOUS CONSULTATION======================================= -->
        <div class="container-fluid " style="padding-top:0px;">
          <div class="bg-primary text-white p-1" (click)="PC_panel_expa = !PC_panel_expa; ">
            <h5 class="mt-2 ml-4">Previous Consultations
              <span *ngIf="!PC_panel_expa" class="pull-right mr-4 ">
                <div (click)="PC_panel_expa = !PC_panel_expa; " class="accordianbutton" *ngIf="diagnosisList?.length">
                  View </div>
                <div (click)="PC_panel_expa = !PC_panel_expa; " class="accordianbutton"
                  *ngIf="diagnosisList?.length==0"> No Data </div>
              </span>
              <span *ngIf="PC_panel_expa" class="pull-right mr-4 ">
                <div (click)="PC_panel_expa = !PC_panel_expa;" class="accordianbutton"> </div>
              </span>
            </h5>
          </div>
          <!-- <div *ngIf="diagnosisList?.length;else no_data_templ"> -->
          <div class="card m-b-30">
            <!-- <div class="card-body" *ngIf="diagnosisList?.length && PC_panel_expa"> -->

            <section class=" mt-3 ml-2 pt-2" *ngIf="diagnosisList?.length && PC_panel_expa">
              <div style=" height:550px; overflow:auto;">
                <div *ngFor="let prevdiag of diagnosisList">

                  <table border="1px" class="table table-sm" style="width:100%">
                    <thead>
                      <tr>
                        <th colspan="2" style="background-color:#e9e9e9;height: 46px;">

                          <div align="center" style="color: blue;">{{prevdiag.dgtime | date:'dd-MM-yyyy'}} </div>
                          <div align="center" style="color: rgba(109, 25, 4, 0.945);" *ngIf="!prevdiag.p_complaints && !prevdiag.hist_p_complaints && !prevdiag.treatment && !prevdiag.examination && !prevdiag.diagnosis 
                              && !prevdiag.curr_med && !prevdiag.remarks && !prevdiag.advice">
                            (Consultation summary Not Available)</div>

                          <div align="center" style="color: rgba(4, 189, 66, 0.767);" *ngIf="prevdiag.cid==cid">
                            (Current Consultation)</div>
                        </th>
                      </tr>
                    </thead>

                    <tr *ngIf="prevdiag.p_complaints">
                      <th style="width:30%">
                        <div>Present complaints :</div>
                      </th>
                      <td style="width:70%;white-space:pre-wrap">
                        <div>{{prevdiag.p_complaints?prevdiag.p_complaints:'--'}} </div>
                      </td>
                    </tr>

                    <tr *ngIf="prevdiag.hist_p_complaints">
                      <th style="width:30%">
                        <div>History of present complaints :</div>
                      </th>
                      <td style="width:70%;white-space:pre-wrap">
                        <div>{{prevdiag.hist_p_complaints?prevdiag.hist_p_complaints:'--'}}</div>
                      </td>
                    </tr>

                    <tr *ngIf="prevdiag.treatment">
                      <th style="width:30%">
                        <div>Treatment :</div>
                      </th>
                      <td style="width:70%;white-space:pre-wrap">
                        <div>{{prevdiag.treatment?prevdiag.treatment:'--'}}</div>
                      </td>
                    </tr>


                    <tr *ngIf="prevdiag.examination">
                      <th style="width:30%">
                        <div>Examination :</div>
                      </th>
                      <td style="width:70%;white-space:pre-wrap">
                        <div>{{prevdiag.examination?prevdiag.examination:'--'}}</div>

                      </td>
                    </tr>


                    <tr *ngIf="prevdiag.diagnosis">

                      <th style="width:30%">
                        <div>Diagnosis :</div>
                      </th>
                      <td style="width:70%;white-space:pre-wrap">
                        <div>{{prevdiag.diagnosis?prevdiag.diagnosis:'--'}} </div>

                      </td>
                    </tr>


                    <tr *ngIf="prevdiag.curr_med">
                      <th style="width:30%">
                        <div>Medicines provided during consultation :</div>
                      </th>
                      <td style="width:70%;white-space:pre-wrap">
                        <div>{{prevdiag.curr_med?prevdiag.curr_med:'--'}}</div>
                      </td>
                    </tr>

                    <tr *ngIf="prevdiag.remarks">
                      <th style="width:30%">
                        <div>Remarks :</div>
                      </th>
                      <td style="width:70%;white-space:pre-wrap">
                        <div>
                          {{prevdiag.remarks?prevdiag.remarks:'--'}}
                        </div>
                      </td>
                    </tr>
                    <tr *ngIf="prevdiag.advice">
                      <th style="width:30%">
                        <div>Advice :</div>
                      </th>
                      <td style="white-space:pre-wrap">
                        <div>{{prevdiag.advice?prevdiag.advice:'--'}}</div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </section>

            <!-- </div> -->


            <div *ngIf="diagnosisList?.length==0 && PC_panel_expa">
              <h5 class="text-center mt-2"> NO RECORDS FOUND</h5>
            </div>
          </div>

          <!-- </div> -->

          <!-- <div id="updocs"></div>
          <ng-template #no_data_templ>
            <h5 class="mt-3 text-center mt-2"> NO RECORDS FOUND</h5>
          </ng-template> -->

          <div id="updocs"></div>
        </div>
        <div id="cconsultation"></div>
        <!-- ============================UPLOADED DOCUMENTS=========================================== -->
        <div class="container-fluid" style="padding-top:0px;">
          <div class="bg-primary text-white p-1" (click)=" UD_panel_expa=!UD_panel_expa;">
            <h5 class="mt-2 ml-4">Uploaded Documents
              <span *ngIf="!UD_panel_expa" class="pull-right mr-4 ">
                <div (click)="UD_panel_expa = !UD_panel_expa;" *ngIf="details?.length>0" class="accordianbutton"> View
                </div>
                <div (click)="UD_panel_expa = !UD_panel_expa;" *ngIf="!details?.length" class="accordianbutton">
                  No Data </div>
              </span>
              <span *ngIf="UD_panel_expa" class="pull-right mr-4 ">
                <div (click)="UD_panel_expa = !UD_panel_expa;" class="accordianbutton"> </div>
              </span>
            </h5>
          </div>
          <!-- <div *ngIf="details?.length;else no_data_templ"> -->
          <div class="card m-b-30">
            <div class="card-body" *ngIf="details?.length>0 && UD_panel_expa">
              <section class="mt-3 ml-2">
                <table id="datatable2" class="table dataTable no-footer" role="grid" aria-describedby="datatable2_info">

                  <thead>
                    <tr role="row">
                      <th scope="col">Description</th>
                      <th scope="col">Name</th>
                      <th scope="col">View</th>
                      <th scope="col">Download</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let doc of details">
                      <td class="text-capitalize">{{ doc?.description }}</td>
                      <td>{{ doc?.name }}</td>
                      <td>
                        <a class="cursor" (click)="previewDocument(doc)">View</a>
                      </td>
                      <td>
                        <a class="cursor" (click)="downloadDocument(doc)">Download</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </div>

            <div *ngIf="!details?.length && UD_panel_expa">
              <h5 class="text-center mt-2"> NO RECORDS FOUND</h5>
            </div>
          </div>
          <!-- </div> -->

          <!-- <ng-template #no_data_templ>
            <h5 class="mt-3 text-center mt-2"> NO RECORDS FOUND</h5>
          </ng-template> -->

        </div>


        <!-- ===============================CURRENT CONSULTATION============================================= -->

        <div class="container-fluid" id="cconsultation" style="padding-top:0px;">
          <div class="bg-primary text-white p-1" (click)="CC_panel_expa = !CC_panel_expa;">
            <h5 class="mt-2 ml-4">Current Consultation
              <span *ngIf="!CC_panel_expa" class="pull-right mr-4 ">
                <div (click)="CC_panel_expa = !CC_panel_expa; " class="accordianbutton"> UPDATE </div>
              </span>
              <span *ngIf="CC_panel_expa" class="pull-right mr-4 ">
                <div (click)="CC_panel_expa = !CC_panel_expa;" class="accordianbutton"> </div>
              </span>
            </h5>
          </div>

          <div class="card m-b-30">
            <div class="card-body col-md-12 d-flex" *ngIf="CC_panel_expa">
              <!-- <div class="col-md-12 d-flex"> -->
              <form #diagForm="ngForm">
                <div class="row">
                  <!-- <div class="col-md-2"></div> 
                    <div class="col-md-4">
                      <div class="col-12 col-sm-12 mt-3"></div>
                      <div class="col-12 col-sm-12 mt-3"></div>
                      <th style="width:20%">
                        <div class="col-12 col-sm-12 mt-4" style="white-space:pre-wrap">Present complaints</div>
                      </th>
                      <div class="col-12 col-sm-12 mt-4"></div>
                      <div class="col-12 col-sm-12 mt-3"></div>
                      <th style="width:20%">
                        <div class="col-12 col-sm-12 mt-4" style="white-space:pre-wrap">History of present complaints
                        </div>
                      </th>
                      <div class="col-12 col-sm-12 mt-4"></div>
                      <div class="col-12 col-sm-12 mt-3"></div>
                      <th style="width:20%">
                        <div class="col-12 col-sm-12 mt-4">Treatment</div>
                      </th>
                      <div class="col-12 col-sm-12 mt-4"></div>
                      <div class="col-12 col-sm-12 mt-3"></div>
                      <th style="width:20%">
                        <div class="col-12 col-sm-12 mt-4">Examination</div>
                      </th>
                      <div class="col-12 col-sm-12 mt-4"></div>
                      <div class="col-12 col-sm-12 mt-4"></div>
                      <th style="width:20%">
                        <div class="col-12 col-sm-12 mt-4">Diagnosis</div>
                      </th>
                      <div class="col-12 col-sm-12 mt-4"></div>
                      <div class="col-12 col-sm-12 mt-4"></div>
                      <th style="width:20%">
                        <div class="col-12 col-sm-12 mt-4">Medicines provided during consultation</div>
                      </th>
                      <div class="col-12 col-sm-12 mt-4"></div>
                      <div class="col-12 col-sm-12 mt-4"></div>
                      <th style="width:20%">
                        <div class="col-12 col-sm-12 mt-4">Remarks</div>
                      </th>
                      <div class="col-12 col-sm-12 mt-4"></div>
                      <div class="col-12 col-sm-12 mt-4"></div>
                      <th style="width:20%">
                        <div class="col-12 col-sm-12 mt-4"> Advice</div>
                      </th>
                    </div> -->
                  <div class="col-md-12">
                    <div class="row">
                      <h6 class="heading_color text-center">CREATE A MEDICAL RECORD</h6>
                    </div>
                    <!-- // CONSULTATION SCREEN Editable -->
                    <form [formGroup]='diagnosisForm' *ngIf="ispastapt==false">
                      <div class="row">

                        <div class="col-12 col-sm-12 form-floating">
                          <!-- <div>Present complaints :</div> -->

                          <!-- here i removed  (change)="isDirty for Present complaints textarea -->
                          <!-- <textarea class="form-control" formControlName="p_complaints" name="p_complaints"
                              value="{{p_complaints}}" id="pc" placeholder="Present complaints"
                              style="height: 150px"></textarea>
                            <label for="pc" class="text-primary">Present complaints</label> -->
                        </div>

                        <div class="col-12 col-md-12 form-floating">
                          <!-- <div>History of present complaints :</div> -->
                          <textarea class="form-control mt-3" formControlName="p_complaints" name="p_complaints"
                            value="{{p_complaints}}" id="pc" placeholder="Pesent complaints"
                            style="height: 150px"></textarea>
                          <label for="pc" class="heading_color">Present complaints</label>
                        </div>

                        <div class="col-12 col-md-12 form-floating">
                          <!-- <div>History of present complaints :</div> -->
                          <textarea class="form-control mt-3" formControlName="his_p_complaints" name="his_p_complaints"
                            value="{{hist_p_complaints}}" id="hpc" placeholder="History of present complaints"
                            style="height: 150px"></textarea>
                          <label for="hpc" class="heading_color">History of present complaints</label>
                        </div>

                        <div class="col-12 col-md-12 form-floating">
                          <!-- <div>Treatment :</div> -->
                          <textarea class="form-control mt-3" formControlName="treatment" name="treatment"
                            value="{{treatment}}" placeholder="Treatment" id="treat" style="height: 150px"></textarea>
                          <label for="treat" class="heading_color">Treatment</label>
                        </div>

                        <div class="col-12 col-md-12 form-floating">
                          <!-- <div>Examination :</div> -->
                          <textarea class="form-control mt-3" formControlName="examination" name="examination"
                            value='{{examination}}' placeholder="Examination" id="exam"
                            style="height: 150px"></textarea>
                          <label for="exam" class="heading_color">Examination</label>
                        </div>

                        <div class="col-12 col-md-12 form-floating">
                          <!-- <div>Diagnosis :</div> -->
                          <textarea class="form-control mt-3" formControlName="diagnosis" name="diagnosis"
                            value="{{diagnosis}}" placeholder="Diagnosis" style="height: 150px" id="diag"></textarea>
                          <label for="diag" class="heading_color">Diagnosis</label>
                        </div>

                        <div class="col-12 col-md-12 form-floating">
                          <!-- <div>Medicines provided during consultation :</div> -->
                          <textarea class="form-control mt-3" formControlName="current_med" name="current_med"
                            value="{{current_med}}" placeholder="Medicines provided during consultation "
                            style="height: 150px" id="mpdc"></textarea>
                          <label for="mpdc" class="heading_color">Medicines provided during consultation </label>
                        </div>

                        <div class="col-12 col-md-12 form-floating">
                          <!-- <div>Remarks :</div> -->
                          <textarea class="form-control mt-3" formControlName="remarks" name="remarks"
                            value="{{remarks}}" placeholder="Remarks" style="height: 150px" id="Remarks"></textarea>
                          <label for="Remarks" class="heading_color">Remarks </label>
                        </div>

                        <div class="col-12 col-md-12 form-floating">
                          <!-- <div>Advice :</div> -->
                          <textarea class="form-control mt-3" formControlName="advice" name="advice"
                            placeholder="Advice" value="{{advice}}" style="height: 150px" id="advice"></textarea><label
                            for="advice" class="heading_color">Advice
                          </label>
                        </div>

                        <div class="col-6 col-md-6 ">
                          <!-- <div class="w-30"> -->
                          <!-- <label class="label1">Followup date:</label> -->
                          <div class="input-group w-100 form-floating">
                            <input required class="form-control mt-3" placeholder="Date of followup date"
                              name="followup_date" formControlName="followup_date" ngbDatepicker #d="ngbDatepicker"
                              data-date-inline-picker="false" [minDate]="minDate"
                              value="{{savfoldt| date:'dd-MM-yyyy'}}" id="fd" />


                            <div class="input-group-append">
                              <button class="btn btn-outline-secondary calendar rounded-0 mt-3" (click)="d.toggle()"
                                type="button" style="line-height: 2.75;">
                                <span class="fa fa-calendar"></span>
                              </button>
                            </div>
                            <label for="fd" class="heading_color">Followup Date </label>

                            <div
                              *ngIf="diagnosisForm.controls.followup_date.errors && !diagnosisForm.controls.followup_date.errors.required"
                              class="invalid-feedback">Invalid date
                            </div>

                          </div>
                          <!-- </div> -->
                        </div>
                      </div>
                    </form>

                    <!-- // PAST CONSULTATION SCREEN NOn-Editable// -->
                    <form [formGroup]='diagnosisForm' *ngIf="ispastapt==true">

                      <div class="row">
                        <div class="col-12 col-sm-12">
                          <textarea (change)="isDirty = true" name="p_complaints" formControlName="p_complaints"
                            value="{{p_complaints}}" rows="2" class="form-control" placeholder="Present complaints"
                            disabled>
                            </textarea>

                        </div>

                        <div class="col-12 col-md-12">
                          <textarea class="form-control" formControlName="his_p_complaints" name="his_p_complaints"
                            value="{{hist_p_complaints}}" placeholder="History of present complaints" rows="2"
                            disabled></textarea>
                        </div>

                        <div class="col-12 col-md-12">
                          <textarea class="form-control" formControlName="treatment" name="treatment"
                            value="{{treatment}}" placeholder="Treatment" rows="2" disabled></textarea>
                        </div>

                        <div class="col-12 col-md-12">
                          <textarea class="form-control" formControlName="examination" name="examination"
                            value='{{examination}}' placeholder="Examination" rows="2" disabled></textarea>
                        </div>

                        <div class="col-12 col-md-12">
                          <textarea class="form-control" formControlName="diagnosis" name="diagnosis"
                            value="{{diagnosis}}" placeholder="Diagnosis" rows="2" disabled></textarea>
                        </div>

                        <div class="col-12 col-md-12">
                          <textarea class="form-control" formControlName="current_med" name="current_med"
                            value="{{current_med}}" placeholder="Medicines provided during consultation " rows="2"
                            disabled></textarea>
                        </div>

                        <div class="col-12 col-md-12">
                          <textarea class="form-control" formControlName="remarks" name="remarks" value="{{remarks}}"
                            placeholder="Remarks" rows="2" disabled></textarea>
                        </div>

                        <div class="col-12 col-md-12">
                          <textarea class="form-control" formControlName="advice" name="advice" placeholder="Advice"
                            value="{{advice}}" rows="2" disabled></textarea>
                        </div>

                        <div class="col-6 col-sm-6">
                          <div class="w-30"><label class="label1">Followup date:</label>
                            <div class="input-group w-100">
                              <input required class="form-control" placeholder="Date of followup date"
                                name="followup_date" formControlName="followup_date" ngbDatepicker #d="ngbDatepicker"
                                data-date-inline-picker="false" [minDate]="minDate"
                                value="{{savfoldt| date:'dd-MM-yyyy'}}" disabled />

                              <div class="input-group-append">
                                <button class="btn btn-outline-secondary calendar rounded-0" (click)="d.toggle()"
                                  type="button" style="line-height: 2.5;">
                                  <span class="fa fa-calendar"></span>
                                </button>
                              </div>

                              <div
                                *ngIf="diagnosisForm.controls.followup_date.errors && !diagnosisForm.controls.followup_date.errors.required"
                                class="invalid-feedback">Invalid date
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                    <div id="presc"></div>
                  </div>
                </div>
              </form>

              <!-- </div> -->
            </div>
          </div>
        </div>

        <!-- ==============================PRESCRIPTION============================================= -->

        <div class="col-lg-12">
          <div class="bg-primary text-white p-1" (click)="P_panel_expa = !P_panel_expa;">
            <h5 class="mt-2 ml-4">Prescription

              <span *ngIf="!P_panel_expa" class="pull-right mr-4 ">
                <div (click)="P_panel_expa = !P_panel_expa; " class="accordianbutton"> UPDATE </div>
              </span>
              <span *ngIf="P_panel_expa" class="pull-right mr-4 ">
                <div (click)="P_panel_expa = !P_panel_expa;" class="accordianbutton"> </div>
              </span>

            </h5>
          </div>

          <!-- ACCORDIAN FOR TEMPLATE SERACH -->
          <br />

          <div *ngIf="P_panel_expa">
            <span class="ml-4 accordiansubheading" style="display:none">
              <span *ngIf="panel_expa && ispastapt==false" (click)="panel_expa = !panel_expa;  this.tmpl_expa = false;">
                CLOSE TEMPLATES
              </span>
              <span *ngIf="!panel_expa && ispastapt==false"
                (click)="panel_expa = !panel_expa;  this.tmpl_expa = false;"> USE TEMPLATES
              </span>
            </span>
            <span *ngIf="panel_expa ">
              <div class="heading_color" *ngIf="ispastapt==false" style="padding:7px;cursor: pointer;font-size: small;"
                (click)="panel_expa = !panel_expa;  this.tmpl_expa = false;">
                CLOSE PRESCRIPTION TEMPLATES </div>
            </span>
            <span *ngIf="!panel_expa ">
              <div class="heading_color" *ngIf="ispastapt==false" style="padding:7px;cursor: pointer;font-size: small;"
                (click)="panel_expa = !panel_expa; this.tmpl_expa = false;">
                Click here for PRESCRIPTION TEMPLATES</div>
            </span>
            <br />
            <div class="col-lg-12" *ngIf="panel_expa">
              <form class="form-group" [formGroup]="tmpl_search_form">
                <div class="card m-b-30">
                  <div class="card-body">
                    <div>
                      <div class="row">
                        <div class="text-primary form-group col-md-2"></div>
                        <div class="text-primary form-group col-md-2 pt-3" style="text-align: right;">Enter Template
                          Name
                        </div>
                        <div class="form-group col-md-4">
                          <input class="form-control" formControlName="tmpl_name_org" type="text">
                        </div>

                        <div class="text-primary form-group col-md-2 pt-2 "><button
                            class="btn btn-primary pl-5 pr-5 mr-2 mb-2 mb-md-2 btn-rounded" type="submit"
                            (click)="searchtmpl()">
                            SEARCH
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

            </div>
            <div *ngIf="tmpl_expa">
              <form class="form-group" [formGroup]="prescriptiontmplForm">
                <div class="container-fluid" *ngIf="cate?.length">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="card m-b-30">
                        <div class="card-body table-responsive">
                          <div class="col-md-12 detail-tbl">
                            <div *ngFor="let q of unique; let j = index;">
                              <div class="card">
                                <div class="card-body">
                                  <span style="color:red; font-weight: 200;">*&nbsp;&nbsp;Please make sure to provide
                                    Duration for Prescriptions.</span><br /><br />
                                  <h5 class="text-primary">{{ q.tmpl_name}}</h5>
                                  <!-- <span style="color:red">*&nbsp;&nbsp;Unfilled items are not added in
                                   List !</span> -->

                                  <br />
                                  <!-- HEADING -->
                                  <div class="row col-12  col-md-12">
                                    <div class="col md-2 prescriptionheading"> Medicine Name</div>
                                    <div class="col md-1 prescriptionheading">Strength</div>
                                    <div class="col md-1 prescriptionheading"> Intake type</div>
                                    <div class="col md-1 prescriptionheading"> Intake Freq</div>
                                    <div class="col md-1 prescriptionheading"> Intake</div>
                                    <div class="col md-3 prescriptionheading"> Starts On</div>
                                    <div class="col md-3 prescriptionheading"> Ends On</div>
                                  </div>
                                  <br /><br />
                                  <div class="row col-12 col-md-12">
                                    <form [formGroup]="forms['appetiteHabits']">
                                      <div class="form-group" formArrayName="medicine_template"
                                        *ngFor="let item of forms['appetiteHabits'].get('medicine_template')['controls']; let i = index;">
                                        <div [formGroupName]="i" *ngIf="q?.tmpl_id  && cate[i]?.tmpl_id">
                                          <div class="row" *ngIf="q.tmpl_id==cate[i].tmpl_id">
                                            <div class="col md-2 prescriptionrow">
                                              {{getMedicineNameLabels(i)}}
                                            </div>
                                            <div class="col md-1 prescriptionrow">
                                              {{getMedicinestrengthLabels(i)}}
                                            </div>
                                            <div class="col md-1 prescriptionrow">
                                              {{getMedicineintakeLabels(i)}}
                                            </div>
                                            <div class="col md-1 prescriptionrow">
                                              {{getMedicineintakefreqLabels(i)}}</div>
                                            <div class="col md-1 prescriptionrow">
                                              {{getMedicineintakefreq_typeLabels(i)}}</div>
                                            <div class="col md-3 ">
                                              <div class="form-group w-30">
                                                <div class="input-group w-100">
                                                  <input required class="form-control"
                                                    placeholder="Medication Start Date(dd/mm/yyyy)"
                                                    formControlName="sdate" ngbDatepicker #d1="ngbDatepicker"
                                                    data-date-inline-picker="false" [minDate]="minDate">
                                                  <div class="input-group-append">
                                                    <button class="btn btn-outline-secondary calendar rounded-0"
                                                      (click)="d1.toggle()" type="button" style="line-height: 2.5;">
                                                      <span class="fa fa-calendar"></span>
                                                    </button>
                                                  </div>
                                                  <!-- <div
                                                  *ngIf="prescriptiontmplForm.controls.sdate.errors && prescriptiontmplForm.controls.sdate.errors.required"
                                                  class="invalid-feedback">This is required</div>
                                                <div
                                                  *ngIf="prescriptiontmplForm.controls.sdate.errors && !prescriptiontmplForm.controls.sdate.errors.required"
                                                  class="invalid-feedback">Invalid date</div> -->
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col md-3">
                                              <div class="form-group w-30">
                                                <div class="input-group w-100">
                                                  <input required class="form-control"
                                                    placeholder="Medication End Date(dd/mm/yyyy)"
                                                    formControlName="edate" ngbDatepicker #d="ngbDatepicker"
                                                    data-date-inline-picker="false" [minDate]="minDate" />
                                                  <div class="input-group-append">
                                                    <button class="btn btn-outline-secondary calendar rounded-0"
                                                      (click)="d.toggle()" type="button" style="line-height: 2.5;">
                                                      <span class="fa fa-calendar"></span>
                                                    </button>
                                                  </div>
                                                  <!-- <div
                                                  *ngIf="forms['appetiteHabits'].get('medicine_template')['controls'].edate"
                                                  class="invalid-feedback">This is
                                                  required</div>
                                                <div
                                                  *ngIf="prescriptiontmplForm.controls.edate.errors && !prescriptiontmplForm.controls.edate.errors.required"
                                                  class="invalid-feedback">Invalid date</div> -->
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div *ngIf="formValidation(i, 'tmpl_id', 'medicine_template')"
                                            class="invalid-feedback">
                                            Please choose Yes/No, It's Required.</div>
                                        </div>
                                      </div>
                                    </form>
                                  </div>
                                  <button type="button" class="btn btn-primary rondBrtn pull-right mr-4" name="submit"
                                    (click)="submitPrescriptionTemplate(q.tmpl_id)">USE THIS TEMPLATE</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

            </div>
            <!-- <div class="card m-b-30">
            <div class="card-body">
              <div class="card-body scroll table-responsive"> -->
            <section>
              <form [formGroup]="prescriptionForm" *ngIf="isEditable">
                <!-- <div class="row"> -->
                <!-- <div class="col-md-12"> -->

                <div class="row col-md-12">
                  <!-- <div class=""> -->
                  <h6 class="heading_color">PRESCRIPTION DETAILS
                  </h6>
                  <label class="label2" style="color:rgb(202, 99, 30)">
                    {{patient?.allergy?"Note *This Patient has Drug Allergies":''}}</label>
                  <!-- <span *ngIf="p_allergy" style="color:rgb(202, 99, 30)"> Note *This Patient has Drug Allergies
                  </span> -->
                  <!-- </div>-->
                </div>

                <div class="row">
                  <div class="col-md-3">
                    <input type="hidden" formControlName="prid" />
                    <input type="text" class="form-control" formControlName="mname" maxlength="50"
                      placeholder="Medicine name" [ngClass]="{ 'is-invalid': prescriptionForm.controls.mname.errors }">
                    <div>
                      <span
                        *ngIf="prescriptionForm.controls.mname.errors && prescriptionForm.controls.mname.errors.required"
                        class="invalid-feedback">
                        This is required
                      </span>
                      <span *ngIf="!prescriptionForm.controls.mname.errors" class="length-hint-span">
                        {{prescriptionForm.controls.mname.value?.length}} / 50
                      </span>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <input type="text" class="form-control" formControlName="strength" maxlength="30"
                      placeholder="Strength ( mg / tbsp / ml )"
                      [ngClass]="{ 'is-invalid': prescriptionForm.controls.strength.errors }">
                    <div>
                      <span
                        *ngIf="prescriptionForm.controls.strength.errors && prescriptionForm.controls.strength.errors.required"
                        class="invalid-feedback">
                        This is required
                      </span>
                      <span *ngIf="!prescriptionForm.controls.strength.errors" class="length-hint-span">
                        {{prescriptionForm.controls.strength.value?.length}} / 30
                      </span>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <select formControlName="intakefreq_type_id" name="intakefreq_type" class="form-control"
                      [ngClass]="{ 'is-invalid': prescriptionForm.controls.intakefreq_type_id.errors }"
                      (click)="freqTypeSelected($event);">
                      <option value="" selected disabled>Select Frequency type</option>
                      <option *ngFor="let x of intakeFreqTypesList" [value]="x.id">{{x.value}}</option>
                    </select>
                    <div>
                      <span *ngIf="prescriptionForm.controls.intakefreq_type_id.errors" class="invalid-feedback">
                        This is required
                      </span>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <select formControlName="intakefreq" name="intakefreq" class="form-control"
                      [ngClass]="{ 'is-invalid': prescriptionForm.controls.intakefreq.errors }">
                      <option value="" selected disabled>Select Frequency</option>
                      <option *ngFor="let x of intakefreqList" [value]="x">{{x}}</option>
                    </select>
                    <div>
                      <span *ngIf="prescriptionForm.controls.intakefreq.errors" class="invalid-feedback">
                        This is required
                      </span>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <select formControlName="intake" name="intake" class="form-control"
                      [ngClass]="{ 'is-invalid': prescriptionForm.controls.intake.errors }">
                      <option value="" disabled selected>Select</option>
                      <option *ngFor="let x of intakeList" [value]="x">
                        {{ x }}
                      </option>
                    </select>
                    <div>
                      <span *ngIf="prescriptionForm.controls.intake.errors" class="invalid-feedback">
                        This is required
                      </span>
                    </div>
                  </div>
                </div>
                <br /><br />
                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group w-30">
                      <div class="input-group w-100">
                        <input required class="form-control" placeholder="Medication Start Date(dd/mm/yyyy)"
                          formControlName="sdate" ngbDatepicker #d1="ngbDatepicker" data-date-inline-picker="false"
                          [minDate]="minDate" [ngClass]="{ 'is-invalid': prescriptionForm.controls.sdate.errors }">
                        <div class="input-group-append">
                          <button class="btn btn-outline-secondary calendar rounded-0" (click)="d1.toggle()"
                            type="button" style="line-height: 2.5;">
                            <span class="fa fa-calendar"></span>
                          </button>
                        </div>
                        <div
                          *ngIf="prescriptionForm.controls.sdate.errors && prescriptionForm.controls.sdate.errors.required"
                          class="invalid-feedback">This is
                          required</div>
                        <div
                          *ngIf="prescriptionForm.controls.sdate.errors && !prescriptionForm.controls.sdate.errors.required"
                          class="invalid-feedback">Invalid date</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group w-30">
                      <div class="input-group w-100">
                        <input required class="form-control" placeholder="Medication End Date(dd/mm/yyyy)"
                          formControlName="edate" ngbDatepicker #d="ngbDatepicker" data-date-inline-picker="false"
                          [ngClass]="{ 'is-invalid': prescriptionForm.controls.edate.errors }" [minDate]="minDate" />
                        <div class="input-group-append">
                          <button class="btn btn-outline-secondary calendar rounded-0" (click)="d.toggle()"
                            type="button" style="line-height: 2.5;">
                            <span class="fa fa-calendar"></span>
                          </button>
                        </div>
                        <div
                          *ngIf="prescriptionForm.controls.edate.errors && prescriptionForm.controls.edate.errors.required"
                          class="invalid-feedback">This is
                          required</div>
                        <div
                          *ngIf="prescriptionForm.controls.edate.errors && !prescriptionForm.controls.edate.errors.required"
                          class="invalid-feedback">Invalid date</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <textarea class="form-control textbox-height" placeholder="Medicine Instruction" maxlength="300"
                      formControlName="remarks"></textarea>
                  </div>

                  <div class="col-md-3">
                    <button type="button" class="btn btn-primary rondBrtn" name="submit"
                      [disabled]="prescriptionForm.invalid"
                      (click)="submitPrescription(prescriptionForm.value)">PRESCRIBE
                      THIS</button>
                  </div>
                </div>

                <!-- </div> -->
                <!-- </div> -->

                <div class="row prescribeThis">
                  <div class="col-md-12 text-center">

                  </div>
                </div>

              </form>

              <div class="bottomFormnew">
                <div class="row">
                  <div class=" col-sm-12">
                    <h6 class="heading_color bottomTitle">
                      Patient's Current Prescription
                      <span class="pull-right mr-4 ">
                        <a href="javascript:void(0);" (click)="printPage($event)" class="fa fa-file-pdf-o"
                          id="CurrentPrescription"></a>
                      </span>
                    </h6>

                    <div *ngIf="currentPrescriptionList?.length;else no_data_templ">
                      <div class="card-body-1 table-responsive"
                        *ngIf="currentPrescriptionList?.length;else no_data_templ">
                        <br>
                        <div class="">
                          <div id="datatable2_wrapper"
                            class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                            <div class="row">
                              <div class="col-sm-12">
                                <table id="datatable2" class="table dataTable no-footer" role="grid"
                                  aria-describedby="datatable2_info">
                                  <thead>
                                    <tr role="row">
                                      <th class="sorting_asc" tabindex="0" aria-controls="datatable2" rowspan="1"
                                        colspan="1" aria-sort="ascending"
                                        aria-label="Name: activate to sort column descending" style="width: 12.3%;">
                                        Medicine</th>
                                      <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1"
                                        colspan="1" style="width: 12.3%;">
                                        Strength</th>
                                      <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1"
                                        colspan="1" style="width: 12.3%">
                                        Frequency</th>
                                      <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1"
                                        colspan="1" style="width: 12.3%">
                                        Med intake</th>
                                      <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1"
                                        colspan="1" style="width: 12.3%">Valid from
                                      </th>
                                      <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1"
                                        colspan="1" style="width: 12.3%">Valid till
                                      </th>
                                      <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1"
                                        colspan="1" style="width: 12.3%">Prescribed on
                                      </th>
                                      <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1"
                                        colspan="1" style="width: 12.3%">Prescribed by
                                      </th>
                                      <th *ngIf="ispastapt==false" class="sorting" tabindex="0"
                                        aria-controls="datatable2" rowspan="1" colspan="1" style="width: 12.3%">Delete
                                        <!--  delete from prescription prid=record.prid  //  cid will store in prescription table (patient id)-->
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody>

                                    <tr role="row" class="odd" *ngFor="let record of currentPrescriptionList">
                                      <td>{{record.mname}}</td>
                                      <td>{{record.strength}}</td>
                                      <td>{{record.intakefreq}}</td>
                                      <td>{{record.intake}}</td>
                                      <td>{{record.sdate| date:'dd-MM-yyyy'}}</td>
                                      <td>{{record.edate| date:'dd-MM-yyyy'}}</td>
                                      <td>{{record.pdate| date:'dd-MM-yyyy'}}</td>
                                      <td>Dr. {{record.first_name}} {{record.last_name}}</td>
                                      <td *ngIf="ispastapt==false">
                                        <a href="javascript:void(0);" class="fa fa-close"
                                          (click)="deletePrescription(record)" style="font-size:18px;color:red;"></a>
                                      </td>

                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                    <ng-template #no_data_templ>
                      <h5 class="text-center mt-2"> NO RECORDS FOUND</h5>
                    </ng-template>
                  </div>
                </div>
              </div>


              <div class="bottomFormnew" *ngIf="isEditable">
                <div class="row">
                  <div class="col-sm-12">
                    <h6 class="heading_color bottomTitle">
                      Patient's Previous Prescription
                      <span class="pull-right mr-4 ">
                        <a href="javascript:void(0);" (click)="printPage($event)" class="fa fa-file-pdf-o"
                          id="PreviousPrescription"></a>
                      </span>
                    </h6>

                    <div *ngIf="previousPrescriptionList?.length;else no_data_templ">
                      <div class="card-body-1 table-responsive">
                        <br>
                        <div class="">
                          <div id="datatable2_wrapper"
                            class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                            <div class="row">
                              <div class="col-sm-12">
                                <table id="datatable2" class="table dataTable no-footer" role="grid"
                                  aria-describedby="datatable2_info">
                                  <thead>
                                    <tr role="row">
                                      <th class="sorting_asc" tabindex="0" aria-controls="datatable2" rowspan="1"
                                        colspan="1" aria-sort="ascending"
                                        aria-label="Name: activate to sort column descending" style="width: 12%;">
                                        Medicine
                                      </th>
                                      <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1"
                                        colspan="1" aria-label="Position: activate to sort column ascending"
                                        style="width: 12%;">
                                        Strength</th>
                                      <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1"
                                        colspan="1" aria-label="Office: activate to sort column ascending"
                                        style="width: 12%">
                                        Frequency</th>
                                      <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1"
                                        colspan="1" aria-label="Office: activate to sort column ascending"
                                        style="width: 12%">
                                        Med intake</th>
                                      <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1"
                                        colspan="1" aria-label="Age: activate to sort column ascending"
                                        style="width: 12%">Valid From
                                      </th>
                                      <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1"
                                        colspan="1" aria-label="Age: activate to sort column ascending"
                                        style="width: 12%">Valid Till
                                      </th>
                                      <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1"
                                        colspan="1" aria-label="Age: activate to sort column ascending"
                                        style="width: 12%">Prescribed
                                        on
                                      </th>
                                      <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1"
                                        colspan="1" aria-label="Age: activate to sort column ascending"
                                        style="width: 12%">Prescribed
                                        by
                                      </th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr role="row" class="odd" *ngFor="let record of previousPrescriptionList">
                                      <td>{{record.mname}}</td>
                                      <td>{{record.strength}}</td>
                                      <td>{{record.intakefreq}}</td>
                                      <td>{{record.intake}}</td>
                                      <td>{{record.sdate| date:'dd-MM-yyyy'}}</td>
                                      <td>{{record.edate| date:'dd-MM-yyyy'}}</td>
                                      <td>{{record.pdate| date:'dd-MM-yyyy'}}</td>
                                      <td>Dr. {{record.first_name}} {{record.last_name}}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                    <div id="labtes"></div>
                    <ng-template #no_data_templ>
                      <h5 class="text-center mt-2"> NO RECORDS FOUND</h5>
                    </ng-template>

                  </div>
                </div>
              </div>

            </section>
            <!-- </div>
            </div>
          </div> -->
          </div>

        </div>

        <!-- ============================LABTEST============================================= -->

        <div class="container-fluid" style="padding-top:0px;">
          <div class="bg-primary text-white p-1" (click)="LT_panel_expa = !LT_panel_expa; ">
            <h5 class="mt-2 ml-4">Lab Test
              <span *ngIf="!LT_panel_expa" class="pull-right mr-4 ">
                <div (click)="LT_panel_expa = !LT_panel_expa; " class="accordianbutton"> UPDATE </div>
              </span>
              <span *ngIf="LT_panel_expa" class="pull-right mr-4 ">
                <div (click)="LT_panel_expa = !LT_panel_expa;" class="accordianbutton"> </div>
              </span>
            </h5>
          </div>
          <div class="card m-b-30">
            <div class="card-body" *ngIf="LT_panel_expa">
              <div class="card-body scroll table-responsive">
                <section class="mt-3 ml-2">

                  <form [formGroup]="labTestsForm" *ngIf="isEditable">
                    <div class="row col-md-10">
                      <!-- <div class=""> -->

                      <!-- <div class=""> -->
                      <h6 class="heading_color">Create Laboratory Test <span style="color:black">(if
                          Required)</span></h6>
                      <!-- </div> -->


                      <div formArrayName="labTests"
                        *ngFor="let record of labTestsForm.get('labTests')['controls']; let i=index;">
                        <div class="row" [formGroupName]="i">
                          <div class="col-9 col-md-4">
                            <div class="text-dark">Test Name</div>
                            <select class="form-control" name="labtest" formControlName="labtest_id"
                              [ngClass]="{ 'is-invalid': record.controls.labtest_id.errors }">
                              <option *ngFor="let test of laboratory_tests" [value]="test.id">
                                {{test.labtest_name}}
                              </option>
                            </select>
                            <div *ngIf="record.controls.labtest_id.errors" class="invalid-feedback">This is
                              required</div>
                          </div>
                          <div class="col-9 col-md-6">
                            <div class="text-dark">Test Description</div>
                            <input type="text" class="form-control" placeholder="Additional information"
                              formControlName="information">
                          </div>
                          <div class="col-4 col-sm-2 col-md-1 m-m text-right mt-4">
                            <button *ngIf="i > 0" type="button" class="btn btn-outline-primary removeitem"
                              style="padding: 12px 16px;" (click)="removeLabTest(i)"><i
                                class="fa fa-close"></i></button>
                          </div>
                          <div class="col-4 col-sm-2 col-md-1 m-m text-right mt-4">
                            <button *ngIf="i == labTestsForm.get('labTests')['controls'].length - 1" type="button"
                              class="btn btn-outline-primary addmore" style="padding: 12px 16px;"
                              (click)="addLabTest();"><i class="fa fa-plus"></i></button>
                          </div>
                          <br>
                        </div>
                      </div>
                      <!-- </div> -->
                    </div> <!-- <br>-->

                    <div class="col-md-12 text-center">
                      <button type="button" class="btn btn-primary rondBrtn" name="submit"
                        (click)="submitLabTests(labTestsForm.value)" [disabled]="labTestsForm.invalid">Confirm lab
                        test</button>
                    </div>

                  </form>
                  <br>
                  <!-- // labtests prescribed By Physcian for this consultation -->
                  <div *ngIf="ispastapt==false" class="bottomFormnew">
                    <div class="row">
                      <div class="col-sm-12">
                        <h6 class="heading_color bottomTitle">
                          Prescribed Laboratory Tests
                          <span>
                            <a href="javascript:void(0);" (click)="printPagee($event)" class="fa fa-file-pdf-o"
                              id="CurrentPrescription"></a>
                            <!-- <i class="fa fa-cloud-download"></i> -->
                          </span>
                        </h6>

                        <div *ngIf="testsList_new?.length;else no_data_templ">
                          <div class="card-body-1 table-responsive">
                            <br>
                            <div class="">
                              <div id="datatable2_wrapper"
                                class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                                <div class="row">
                                  <div class="col-sm-12 table-responsiv">
                                    <table id="datatable2" class="table dataTable no-footer" role="grid"
                                      aria-describedby="datatable2_info">
                                      <thead>
                                        <tr role="row">
                                          <th class="sorting_asc" tabindex="0" aria-controls="datatable2" rowspan="1"
                                            colspan="1" aria-sort="ascending"
                                            aria-label="Name: activate to sort column descending" style="width: 16%;">
                                            Date
                                          </th>
                                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1"
                                            colspan="1" aria-label="Position: activate to sort column ascending"
                                            style="width: 16%;">Name
                                            of test</th>
                                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1"
                                            colspan="1" aria-label="Office: activate to sort column ascending"
                                            style="width: 16%">Remarks
                                          </th>

                                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1"
                                            colspan="1" aria-label="Age: activate to sort column ascending"
                                            style="width: 16%">Action
                                            <!--delete from patient_labtest where testid=record.testid -->
                                          </th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        <tr role="row" class="odd" *ngFor="let record of testsList_new">
                                          <td>{{record.tdate| date:'dd-MM-yyyy'}}</td>
                                          <td>{{record.labtest_name}}
                                            <input type="hidden" name="testid" value="record.testid">
                                          </td>
                                          <td>{{record.remarks}}</td>
                                          <td>
                                            <a href="javascript:void(0);" class="fa fa-close"
                                              (click)="deleteLabtest(record)" style="font-size:18px;color:red;"></a>
                                          </td>
                                        </tr>
                                      </tbody>

                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>

                        <ng-template *ngIf="ispastapt==false" #no_data_templ>
                          <h5 class="text-center mt-2"> NO RECORDS FOUND</h5>
                        </ng-template>

                      </div>
                    </div>
                  </div>

                  <!-- // Old labtests prescribed By Physcian VERSION 2 -->
                  <div class="bottomFormnew">
                    <div class="row">
                      <div class="col-sm-12">
                        <h6 class="heading_color bottomTitle">
                          Laboratory Test Analysis
                        </h6>

                        <div *ngIf="testsList?.length;else no_data_templ">
                          <div class="card-body-1 table-responsive">
                            <br />
                            <div class="">
                              <div id="datatable2_wrapper"
                                class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                                <div class="row">
                                  <div class="col-sm-12 table-responsiv">
                                    <table id="datatable2" class="table dataTable no-footer" role="grid"
                                      aria-describedby="datatable2_info">
                                      <thead>
                                        <tr role="row">
                                          <th class="sorting_asc" tabindex="0" aria-controls="datatable2" rowspan="1"
                                            colspan="1" aria-sort="ascending"
                                            aria-label="Name: activate to sort column descending" style="width: 16%">
                                            Date
                                          </th>
                                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1"
                                            colspan="1" aria-label="Position: activate to sort column ascending"
                                            style="width: 16%">
                                            Name of test
                                          </th>
                                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1"
                                            colspan="1" aria-label="Office: activate to sort column ascending"
                                            style="width: 16%">
                                            Remarks
                                          </th>
                                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1"
                                            colspan="1" aria-label="Age: activate to sort column ascending"
                                            style="width: 16%">
                                            Review
                                          </th>
                                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1"
                                            colspan="1" aria-label="Age: activate to sort column ascending"
                                            style="width: 16%">
                                            Status
                                          </th>
                                          <th *ngIf="ispastapt==false" class="sorting" tabindex="0"
                                            aria-controls="datatable2" rowspan="1" colspan="1"
                                            aria-label="Age: activate to sort column ascending" style="width: 16%">
                                            Attachment
                                          </th>

                                          <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1"
                                            colspan="1" aria-label="Age: activate to sort column ascending"
                                            style="width: 16%">
                                            Action
                                          </th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        <tr role="row" class="odd" *ngFor="let record of testsList">
                                          <td>
                                            {{ record.tdate | date: "dd-MM-yyyy" }}
                                          </td>
                                          <td>
                                            {{ record.labtest_name }}
                                            <input type="hidden" name="testid" value="record.testid" />
                                          </td>
                                          <td>{{ record.remarks }}</td>
                                          <td>{{ record.review }}</td>
                                          <td>{{ record.tstat }}</td>
                                          <td>



                                            <div class="gridimg" *ngFor="let report of record.attachments;let i=index;">
                                              <div
                                                *ngIf="record.attachments.ext[i]!='' && record.attachments.ext[i]=='pdf'">
                                                <a class="cursor" (click)="previewDocuments(report)">
                                                  <span class="fa-stack fa-lg">
                                                    <i class="fa fa-circle fa-stack-2x"></i>
                                                    <i class="fa fa-file-pdf-o fa-stack-1x fa-inverse"></i>
                                                  </span>
                                                </a>
                                              </div>
                                              <div
                                                *ngIf="record.attachments.ext[i]!='' &&  record.attachments.ext[i]!='pdf'">
                                                <a class="cursor" (click)="previewDocuments(report)"> <img
                                                    [src]="report"
                                                    style="width: 30px;height:30px; border-radius:50%;max-width:100%;cursor:pointer"
                                                    class=" modal-hover-opacity" data-toggle="modal"
                                                    data-target="#myModal" /> </a>
                                              </div>

                                            </div>
                                          </td>
                                          <td *ngIf="ispastapt==false">
                                            <a (click)="
                                                  openEditLabTest(
                                                    labTestModal,
                                                    record
                                                  )
                                                " class="eyellow">
                                              <i class="fa fa-pencil"></i>
                                            </a>
                                          </td>
                                        </tr>
                                      </tbody>

                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <ng-template #no_data_templ>
                          <h5 class="text-center mt-2"> NO RECORDS FOUND</h5>
                        </ng-template>


                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="row" *ngIf="isEditable">
                    <div class="col-md-6 text-center">
                      <button type="button" (click)="savePatient()" class="btn btn-success rondBrtn" name="save">
                        SAVE </button>
                    </div>
                    <div class="col-md-6 text-center">
                      <button type="button" (click)="updatePatient()" class="btn btn-success rondBrtn" name="submit">
                        CONFIRM & COMPLETE THIS CONSULTATION </button>
                    </div>
                  </div>

                </section>
              </div>
            </div>
          </div>


        </div>

        <!-- ========================================================================================= -->

      </div>
    </div>
  </div>

  <!-- GOTO TOP -->
  <a [ngClass]="{'button-scroll-to-top--show': showScroll}" (click)="scrollToTop()" class="button-scroll-to-top">
    <i class="fa fa-arrow-circle-o-up" style="font-size:48px;color:	rgb(211, 211, 211)"></i>
  </a>
  <!-- ============== LAB TEST ENTRY MODAL ================== -->
  <ng-template #labTestModal let-modal>
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLabel">
        {{ selectedLabTest.labtest_name }}
        <span>Test Date: {{ selectedLabTest.tdate | date: "dd-MM-yyyy" }}</span>
      </h5>
      <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <form [formGroup]="modalForm">
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-12 mleft">
            <div class="remark">
              <h6>submit your review</h6>
              <input type="hidden" formControlName="testid" />
              <div class="form-group">
                <textarea formControlName="review" id="review" class="textareafield" placeholder="Review"></textarea>
              </div>
              <div class="form-group">
                <textarea formControlName="remarks" id="remarks" class="textareafield" placeholder="Remarks"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Cross click')">
        Cancel
      </button>
      <button type="button" class="btn btn-primary"
        (click)="updateLabTest(modalForm.value); modal.dismiss('Cross click')">
        Update Report
      </button>

    </div>
  </ng-template>
  <!-- ======================================= -->

  <!-- ==============PREVIOUS HABIT DISPLAY MODAL ================== -->
  <ng-template #habitModal let-modal>
    <div class="container-fluid ">
      <div style="text-align:right;"> <br /><a href="javascript:void(0);" class="fa fa-close" (click)="modal.dismiss()"
          style="font-size:18px;color:red;"></a>
      </div>

      <div class="bg-primary text-white p-1">
        <h5 class="mt-2 ml-4"> Patient's Habit History</h5>
      </div>

      <div class="card m-b-30">
        <div class="card-body">
          <div class="card-body scroll table-responsive">
            <div class="col-sm-12">
              <table id="datatable2" class="table dataTable no-footer" role="grid" aria-describedby="datatable2_info">
                <thead>
                  <tr role="row" align="center">
                    <th class="sorting_asc" tabindex="0" aria-controls="datatable2" aria-sort="ascending"
                      aria-label="Name: activate to sort column descending">
                      Date</th>
                    <th *ngFor="let record of patient.patient_appetite" class="sorting" tabindex="0"
                      aria-controls="datatable2">
                      {{record.description}}</th>
                  </tr>
                </thead>

                <tbody>
                  <tr role="row" class="odd" *ngFor="let report of  patent_appetite_details;let i=index;"
                    align="center">
                    <td *ngIf="patent_appetite_details[i][1].ap_date; else elsepart">
                      {{patent_appetite_details[i][1].ap_date |
                      date:"dd-MM-yyyy"}}</td>
                    <ng-template #elsepart>
                      <td>Intial Data</td>
                    </ng-template>
                    <td *ngFor="let record of patent_appetite_details[i];">{{
                      record.habit_details?record.habit_details + ' qty ':'-'}}<br />
                      {{record.habit_details? record.frequency:''}}<br />{{record.habit_details?record.since:''}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>


    </div>

  </ng-template>
  <!-- ======================================= -->


  <!-- ============== PREVIOUS LIFE DISPLAY MODAL ================== -->
  <ng-template #lifeModal let-modal>
    <div class="container-fluid ">
      <div style="text-align:right;"> <br /><a href="javascript:void(0);" class="fa fa-close" (click)="modal.dismiss()"
          style="font-size:18px;color:red;"></a></div>

      <!-- <div class="row">
        <div class="container-fluid"> -->
      <div class="bg-primary text-white p-1">
        <h5 class="mt-2 ml-4"> Patient's Life Style History</h5>
      </div>
      <div class="card m-b-30">
        <div class="card-body">
          <div class="card-body scroll table-responsive">
            <div class="col-sm-12">
              <table id="datatable2" class="table dataTable no-footer" role="grid" aria-describedby="datatable2_info">
                <thead align="center">
                  <tr role="row">
                    <th class="sorting_asc" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                      aria-sort="ascending" aria-label="Name: activate to sort column descending">
                      DATE</th>
                    <th *ngFor="let record of patient.patient_lifestyle" class="sorting" tabindex="0"
                      aria-controls="datatable2" rowspan="1" colspan="1">
                      {{record.activity}}</th>
                  </tr>
                </thead>

                <tbody align="center">
                  <tr role="row" class="odd" *ngFor="let report of  patent_lifestyle_details;let i=index;">
                    <td *ngIf="patent_lifestyle_details[i][1].ap_date; else elsepart">
                      {{patent_lifestyle_details[i][1].ap_date
                      | date:"dd-MM-yyyy"}}</td>
                    <ng-template #elsepart>
                      <td>Intial Data</td>
                    </ng-template>
                    <td *ngFor="let record of patent_lifestyle_details[i];">
                      {{record.duration?record.duration+ ' hours ':'-'}}
                      {{record.freq?' / '+ record.freq:'-'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
      <!-- </div>
      </div> -->

    </div>
  </ng-template>
  <!-- ======================================= -->


  <!-- ============== PREVIOUS stats DISPLAY MODAL ================== -->
  <ng-template #statsModal let-modal>
    <div class="container-fluid ">
      <div style="text-align:right;"> <br /><a href="javascript:void(0);" class="fa fa-close" (click)="modal.dismiss()"
          style="font-size:18px;color:red;"></a></div>

      <div class="bg-primary text-white p-1">
        <h5 class="mt-2 ml-4"> Patient Statistic History - {{previous_stats[0]?.stats_name}}</h5>
      </div>



      <div class="card m-b-30">
        <div class="card-body">
          <div class="card-body scroll table-responsive">
            <div class="col-sm-12">
              <table id="datatable2" class="table dataTable no-footer" role="grid" aria-describedby="datatable2_info">
                <thead>
                  <tr role="row" align="center">
                    <th class="sorting_asc" tabindex="0" aria-controls="datatable2" aria-sort="ascending"
                      aria-label="Name: activate to sort column descending" style="width: 20%;">Date</th>

                    <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                      style="width: 20%;">Value</th>
                    <th class="sorting" tabindex="0" aria-controls="datatable2" rowspan="1" colspan="1"
                      style="width: 20%;">Created by</th>
                  </tr>
                </thead>

                <tbody *ngIf="previous_stats?.length;else no_data_templ">
                  <tr role="row" class="odd" *ngFor="let record of previous_stats" align="center">
                    <td>{{record.stats_date_time | date: "dd-MM-yyyy" }}</td>
                    <td>{{record.stats_std_val?record.stats_std_val:'--'}}
                      {{record.stats_std_val?record.stats_std_uom:''}}</td>
                    <td>{{record.stats_by?record.stats_by:'--' }}</td>
                  </tr>
                </tbody>
                <ng-template #no_data_templ>
                  <tbody *ngIf="previous_stats?.length;else no_data_templ">
                    <tr role="row" class="odd">
                      <td colspan="2">
                        <h5 class="text-center mt-2"> NO RECORDS FOUND</h5>
                      </td>
                    </tr>
                  </tbody>
                </ng-template>

              </table>
            </div>
          </div>
        </div>
      </div>


    </div>

  </ng-template>
</div>

<!-- PDF popup UI -->
<ng-template #PDFModal>
  <div>
    <div class="modal-header">
      <button type="button" class="close" (click)=closeModal()>&times;</button>
    </div>
    <div>
      <pdf-viewer [src]="pdfSrc" [render-text]="true" style="display: block;"></pdf-viewer>
    </div>
  </div>
</ng-template>

<div *ngIf="onlineCheckin">
  <label class="text-color chat-label">LIVE CHAT -->
  </label>
  <input type="checkbox" id="check" />
  <label *ngIf="isEditable" (click)="showChatModal = showChatModal ? false : true" class="chat-btn" for="check">
    <i class="fa fa-commenting-o comment"></i>
    <!-- <i class="fa fa-close close"></i> -->
  </label>
</div>

<br />


<div class="wrapper" *ngIf="showChatModal" (click)="focus = true" [ngClass]="{ focusClass: focus === true }">
  <!--<div class="row">-->
  <!--<div class="mx-auto">-->
  <form [formGroup]="chatForm" #chatMsgForm>
    <div class="card border-primary border-2">
      <div class="card-header card-header-color d-flex text-white font-size-15 font-weight-600 justify-content-between">
        <div>CHAT BOX</div>
        <div *ngIf="room_id">Room Id: {{ room_id }}</div>
        <div>
          <a *ngIf="chatStarted" style="font-size: 25px; color: cyan" class="fa mr-3 cursor" [ngClass]="{
              'fa-video-camera': true
            }" aria-hidden="true" (click)="
              notifyCall('video') && focus == false
            "></a>
          <b class="cursor" (click)="showChatModal = false">-</b>
        </div>
      </div>
      <div class="card-body chat-care" #chatScroll [scrollTop]="chatScroll.scrollHeight">
        <div *ngIf="!chatStarted; else elseSession" class="text-center">
          <label>------ No Messages ------</label>
        </div>
        <ng-template #elseSession>
          <div class="text-center">
            <label>------ Session started ------</label>
          </div>
        </ng-template>
        <ul class="chat" *ngFor="let msg of messages; let i = index">
          <li *ngIf="msg?.id == patient?.pid" class="patientChat clearfix">
            <span class="chat-img left clearfix mx-1">
              <i class="fa fa-user" style="font-size: 23px; color: orange" alt="Patient"></i>
            </span>
            <div class="chat-body-patient clearfix">
              <div class="header clearfix">
                <strong class="primary-font" style="color: orange">{{
                  patient?.first_name
                  }}</strong>
                &nbsp;&nbsp;
                <small class="right text-muted ml-3">
                  <span class="glyphicon glyphicon-time"></span>{{
                  msg.date | date: "dd-MMM-yyyy
                  (HH:mm)"
                  }}</small>
              </div>

              <img *ngIf="checkMsgType(msg?.body) === 'image'" style="width: 250px" src="{{ msg.body?.previewUrl }}"
                id="chatImage" (click)="previewImg(i)" alt="image" />

              <p *ngIf="checkMsgType(msg?.body) === 'string'">
                {{ msg?.body }}
              </p>

              <video *ngIf="checkMsgType(msg?.body) === 'video'" src="{{ msg.body?.previewUrl }}" id="chatVideo"
                style="width: 250px" alt="video" type="video/mp4" controls></video>

              <a *ngIf="checkMsgType(msg?.body) === 'application'" class="fa fa-file-pdf-o mr-2">
                <br />
                <a href="javascript:void(0);" aria-hidden="true" (click)="previewImg(i)"
                  style="color: blue; font-weight: normal">&nbsp;{{ msg.body?.name }}</a>
              </a>
            </div>
            <i *ngIf="
                checkMsgType(msg?.body) === 'video' ||
                checkMsgType(msg?.body) === 'image' ||
                checkMsgType(msg?.body) === 'application'
              " class="fa fa-download ml-2" aria-hidden="true" style="font-size: 15px; cursor: pointer"
              (click)="downloadDocument(msg.body)"></i>
          </li>
          <li *ngIf="msg?.id == physicianDetail?.u_id" class="physicianChat clearfix">
            <span class="chat-img right clearfix mx-1">
              <i class="fa fa-user-md" style="font-size: 23px; color: blue" alt="Physician"></i>
            </span>
            <div class="chat-body-physician clearfix">
              <div class="header clearfix">
                <small class="left text-muted">
                  <span class="glyphicon glyphicon-time"></span>
                  {{ msg.date | date: "dd-MMM-yyyy (HH:mm)" }}</small>&nbsp;&nbsp;
                <strong class="right primary-font mr-2" style="color: blue">{{
                  physicianDetail?.first_name
                  }}</strong>
              </div>

              <img *ngIf="checkMsgType(msg?.body) === 'image'" style="width: 250px" src="{{ msg.body?.previewUrl }}"
                id="chatImage" alt="image" />

              <p *ngIf="checkMsgType(msg?.body) === 'string'">
                {{ msg.body }}
              </p>

              <video *ngIf="checkMsgType(msg?.body) === 'video'" src="{{ msg.body?.previewUrl }}" id="chatVideo"
                style="width: 250px" alt="video" type="video/mp4" controls></video>

              <a *ngIf="checkMsgType(msg?.body) === 'application'" class="fa fa-file-pdf-o mr-2">
                <br />
                <a href="javascript:void(0);" aria-hidden="true" (click)="previewImg(i)"
                  style="color: blue; font-weight: normal">&nbsp;{{ msg.body?.name }}</a>
              </a>
            </div>
            <i *ngIf="
                checkMsgType(msg?.body) === 'video' ||
                checkMsgType(msg?.body) === 'image' ||
                checkMsgType(msg?.body) === 'application'
              " class="fa fa-download ml-2" aria-hidden="true" style="font-size: 15px; cursor: pointer"
              (click)="downloadDocument(msg.body)"></i>
          </li>
        </ul>
        <ul *ngIf="typingStatus?.status" class="typing-status">
          {{
          typingStatus?.status
          }}...
        </ul>
      </div>
      <div class="card-footer card-footer-color">
        <div *ngIf="!chatStarted" class="text-center">
          <button class="btn btn-primary" (click)="startChat()" [disabled]="!room_id">
            START CHAT
          </button>
        </div>

        <div *ngIf="chatStarted" class="input-group">
          <textarea id="btn-input" type="text" formControlName="chat_msg" class="form-control input-sm"
            placeholder="Type your message here..." rows="2" cols="3" style="line-height: 2; overflow: hidden"
            (keydown)="sendStatusTyping($event)" (keydown.enter)="sendMessage()"></textarea>
          <div class="image-upload">
            <label class="btn btn-outline-secondary calendar rounded-0" for="file-input"
              style="line-height: 2.5; background: white" id="attachFile">
              <span class="fa fa-paperclip fa-rotate-90" style="font-size: 32px; color: black"></span>
            </label>
            <input id="file-input" type="file" accept="application/pdf, image/*, docx/*"
              (change)="selectFile($event)" />
          </div>
          <span class="input-group-btn">
            <button class="btn btn-primary mt-2 ml-2" id="btn-chat" (click)="sendMessage()">
              <i class="fa fa-paper-plane"></i>
            </button>
          </span>
        </div>
      </div>
    </div>
  </form>
  <!--</div>-->
  <!--</div>-->
</div>
<!-- video call -->
<div *ngIf="showOnlineJoinCall" [ngClass]="{
  minWindow: isMinimize === true,
  'video-screen': isMinimize === false
}" (click)="focus = false" style="transform: translate3d(0px, 111px, 0px)" cdkDrag>
  <div>
    <div class="float-right">
      <span *ngIf="!isMinimize" class="mr-2 cursor" (click)="isMinimize = true"><b>_</b></span>
      <button *ngIf="!isMinimize" type="button" class="close mr-2" (click)="closeVideoScreen()">
        &times;
      </button>
      <img *ngIf="isMinimize" width="10px" class="mr-2 cursor" src="../../../assets/images/maximize.svg"
        (click)="isMinimize = false" />
    </div>
    <div>
      <!-- <i class="fa fa-close font-size-14"> Press Escape key to clsoe the preview</i> -->
      <h3 *ngIf="!isMinimize">Call</h3>
    </div>
    <div class="w-100">
      <app-home #home [isMinimize]="isMinimize" [aptid]="room_id" role="dr"></app-home>
    </div>
  </div>
</div>
<!-- end video call -->
<!-- Join ChatRoom Notification -->
<ng-template #joinChatNotification let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h2 class="modal-title">Join Chat Notification</h2>
  </div>

  <!-- modal header -->

  <div *ngIf="notificationMessage" class="modal-body">
    {{ notificationMessage }}
    <!-- modal content -->
  </div>

  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-primary" (click)="closePopUp()">
      ok
    </button>
  </div>
</ng-template>

<!-- end -->